import AbstractScene from './AbstractScene.js';
import { Colors } from '../consts/Colors.js';
import Popup from '../prefabs/Popup.js';
import PopupFin from '../prefabs/PopupFin.js';
import { TextContents, CartesInfos, ZonesInfos } from '../consts/DataGame4.js';
import Deck4 from '../prefabs/game4/Deck4.js';
import Zone4 from '../prefabs/game4/Zone4.js';
import EndBoard from '../prefabs/EndBoard.js';

export default class Game4 extends AbstractScene {
    constructor() {
        super({
            key: "Game4"
        })
    }
    init(data) {
        this._init(data);
        this.zonesInfos = ZonesInfos;
    }

    preload() {
        this._preload();
        this.cameras.main.setBackgroundColor(Colors.Text.Beige);
    }

    create() {
        console.log('Create :',this.scene.key);
        CartesInfos.sort(() => Math.random() - 0.5);

        this.transitionRect = this.add.rectangle(0, 0, 1920, this.height, Colors.Elmt.DarkBlue, 1).setOrigin(0, 0).setDepth(12)

        // Ajout elements du fond
        let titre = this.add.sprite(725, 170, "titre4")
        this.bfr = this.add.sprite(1212, 620, "bfr")
        let augmenter_ca = this.add.sprite(1212, 196, "augmenter_ca")
        this.fr = this.add.sprite(230, 620, "fr")

        // Ajout element interactifs
        this.addDropZone()

        // Ajout element decoratifs
        let centre = this.add.sprite(720, 622, "centre")
        centre.setDepth(4)


        this.deck4 = new Deck4(this, 1700, 540, this.zones);
        this.deck4.setDepth(5)

        this.transitionIn()
    }

    launchPopup() {
        this.popup = new Popup(this, TextContents.popup.text, 756, false);
        this.popup.setDepth(10)
        this.popup.introBtn.setClickFunction(() => {
            this.popup.destroy();
            let delay = 0;
            let indices = [0,1,2,3,4,5,0,1,2,3,4,5]
            indices.forEach((indice, index) => {
                this.zones.getChildren()[indice].bounceAnimation(delay)
                delay += 200
            });
            this.zones.getChildren().forEach(zone => {
                zone.setActive();
                
            });
        })
    }

    launchEndPopup() {
        this.popup = new PopupFin(this, TextContents.popupFin.text, 756);
        this.popup.setDepth(10)
        this.popup.introBtn.setClickFunction(() => {
            this.transitionOut()

        })
    }


    addDropZone() {
        this.zones = this.add.group();
        this.zonesInfos.forEach( zoneInfo => {
            let newZone = new Zone4(this, zoneInfo)
            newZone.setDepth(3)
            this.zones.add(newZone)
        })
    }
    resetDropZones(){
        this.zones.getChildren().forEach(zone => {
            zone.reset()
        });
    }

    setActionBackground(index){
        const pos = [
            {x: 96+ this.fr.x - this.fr.width/2, y: 90 + this.fr.y - this.fr.height/2},
            {x: 113+ this.fr.x - this.fr.width/2, y:327+ this.fr.y - this.fr.height/2},
            {x: 108+ this.fr.x - this.fr.width/2, y: 565+ this.fr.y - this.fr.height/2},

            {x: 98+ this.bfr.x - this.bfr.width/2, y: 102+ this.bfr.y - this.bfr.height/2},
            {x: 96+ this.bfr.x - this.bfr.width/2, y: 319+ this.bfr.y - this.bfr.height/2},
            {x: 110+ this.bfr.x - this.bfr.width/2, y:556+ this.bfr.y - this.bfr.height/2},
        ]
        let action = this.add.group()
        let bg = this.add.sprite(pos[index-1].x, pos[index-1].y, "fond_"+(index)).setOrigin(0,0).setAlpha(0)
        action.add(bg)
        if(index == 2){
            let bg1 = this.add.sprite(53, 576, "perso").setOrigin(0,0).setAlpha(0)
            action.add(bg1)
            let bg2 = this.add.sprite(53, 724, "perte_controle").setOrigin(0,0).setAlpha(0)
            action.add(bg2)
        } else if(index == 3){
            let bg1 = this.add.sprite(53, 961, "niveau_endettement").setOrigin(0,0).setAlpha(0)
            action.add(bg1)
        }

        this.tweens.add({
            targets: action.getChildren(),
            alpha: 1,
            duration: 500
        })
    }

    transitionIn() {
        // this.transitionRect.setAngle(180);
        let X = 1480
        this.tweens.add({
            targets: this.transitionRect,
            duration: 500,
            ease: 'Linear',
            width: this.width-X,
            x: X,
            onComplete: () => {
                this.transitionRect.setDepth(-1)
                this.launchPopup();
            }
        })

    }

    transitionOut() {
        this.tweens.add({
            targets: this.deck1,
            duration: 500,
            alpha: 0,
            onComplete: () => {
                this.transitionRect.setDepth(12)
                this.tweens.add({
                    targets: this.transitionRect,
                    x: 0,
                    duration: 500,
                    onUpdate: () => {
                        this.transitionRect.width = 1920 - this.transitionRect.x;
                        // this.transitionRect.x = 1904 - this.transitionRect.width
                    },
                    onComplete: () => {
                        this.nextScene()
                    }
                })
            }
        })
    }
}